import fetch from 'auth/FetchInterceptor'

const InsuranceService = {}

InsuranceService.fetch = function () {
	return fetch({
		url: '/insurance',
		method: 'get'
	})
}

InsuranceService.create = function (data) {
	return fetch({
		url: '/insurance',
		method: 'post',
		data
	})
}

InsuranceService.update = function (data) {
	return fetch({
		url: '/insurance/' + data.id,
		method: 'put',
		data
	})
}

InsuranceService.delete = function (id) {
	return fetch({
		url: '/insurance/' + id,
		method: 'delete'
	})
}

export default InsuranceService;